module.exports = __webpack_public_path__ + "img/chargel.5d03426c.png";